import {useEffect, useState} from "react";
import axiosInstance from "../API/Axios/AxiosConfig";
import {toast} from "react-toastify";
import URLS from "../API/Axios/URLS";


export default function useVocab(url) {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [category, setCategory] = useState(url);
    const [filter, setFilter] = useState({});


    function load(pageNumber = 1, pageSize = 10) {
        if (isLoading) return;
        setIsLoading(true)
        axiosInstance.get(URLS.getVocab, {
            params: {
                ...filter,
                category: category,
                page: pageNumber,
                page_size: pageSize
            }
        }).then(res => {
            setData(res.data)
        }).catch(err => {
            toast.error(err.response.data.detail || "Something went wrong");
        }).finally(() => {
            setIsLoading(false)
        })
    }

    function loadNextPage() {
        if (data?.next) {
            load(data?.currentPage + 1)
        }
    }

    function loadPrevPage() {
        if (data?.previous) {
            load(data?.currentPage - 1)
        }
    }

    function loadSpecificPage(pageNumber) {
        if (pageNumber < 1 || pageNumber > data?.totalPages)
            return;
        load(pageNumber)
    }


    function UpdateFilter(filter) {
        setFilter((old) => {
            return {
                ...old,
                ...filter
            }
        })
    }

    useEffect(() => {
        // if filter have keys then load
        if (Object.keys(filter).length > 0) {
            load()
        }
    }, [filter]);


    useEffect(() => {
        if (category) {
            load()
        }
    }, [category])


    let actions = {
        load,
        loadNextPage,
        loadPrevPage,
        setCategory,
        loadSpecificPage,
        UpdateFilter
    }

    return (
        [data, filter, isLoading, actions]
    )


}